import DeliveryType from '@/models/enums/DeliveryType'
import PaymentMode from '@/models/enums/PaymentMode'
import PaymentType from '@/models/enums/PaymentType'

// режимы, из которых оператор выбирает; колл-центр платежи не проводит - у него одна позиция
export function availablePaymentModes ({ deliveryType, canPayNow, isCallCenter }) {
  const isSelf = deliveryType === DeliveryType.Self

  if (isCallCenter) {
    return [isSelf ? PaymentMode.PayLater : PaymentMode.Courier]
  }

  const modes = isSelf
    ? [PaymentMode.PayNow, PaymentMode.PayLater]
    : [PaymentMode.Courier, PaymentMode.PayNow]

  return modes.filter(mode => mode !== PaymentMode.PayNow || canPayNow)
}

// доставка: курьер берёт только методы доставки, на точке - только методы самовывоза;
// null = набор не настроен, не ограничиваем; [] = настроен, но ничего не принимают
export function isTypeAcceptedFor (basket, mode, paymentType) {
  if (basket.deliveryType !== DeliveryType.Delivery) {
    return true
  }

  const accepted = mode === PaymentMode.Courier
    ? basket.courierPaymentTypes
    : mode === PaymentMode.PayNow ? basket.restaurantPaymentTypes : null

  return !Array.isArray(accepted) || accepted.includes(paymentType)
}

// кнопки типов: тип показываем, если его принимают хотя бы в одном доступном режиме
export function acceptedPaymentTypes (basket, modes) {
  return (basket?.availablePaymentTypes || [])
    .filter(type => modes.some(mode => isTypeAcceptedFor(basket, mode, type)))
}

export function enabledPaymentModes (basket, modes, paymentType) {
  return modes.filter(mode => isTypeAcceptedFor(basket, mode, paymentType))
}

export function paymentModeItems (basket, modes, paymentType) {
  return modes.map(mode => ({
    value: mode,
    text: PaymentMode.getPickLabel(mode, basket.deliveryType),
    disabled: !isTypeAcceptedFor(basket, mode, paymentType),
  }))
}

// почему позиция режима погасла - по выбранному методу
export function disabledModeHint (basket, modes, paymentType) {
  const byType = { [PaymentType.Terminal]: 'картой', [PaymentType.Cash]: 'наличными' }
  const typeName = byType[paymentType] || PaymentType.getName(paymentType).toLowerCase()
  const disabled = mode => modes.includes(mode) && !isTypeAcceptedFor(basket, mode, paymentType)

  if (disabled(PaymentMode.Courier)) {
    return `Курьер не принимает оплату ${typeName} - оплатить можно только на кассе филиала`
  }
  if (disabled(PaymentMode.PayNow)) {
    return `На кассе филиала не принимают оплату ${typeName} - оплатить можно только курьеру`
  }

  return null
}
